import $ from 'jquery';

$(document).ready(function () {
  acfSoldOutBlock();
});

function acfSoldOutBlock() {
  $('.js-acf-example-block').each(function () {});
}
